import styles from './index.module.scss'
import Utils from '@utils/utils'
import {
    RESOLUTION_ALIGN, BATCH_IMAGES_TYPE, RELIGHT_MODE, MODEL_EXPRESSION,
    MODEL_PROVIDER, SMART_DETAIL_PLATFORM_LABEL_MAP, SMART_DETAIL_LANG_LABEL_MAP, IMAGE_TYPE
} from '@utils/CONST'
import RefListModal from '../../../../RefListModal'
import { useRef, useState, useMemo, useEffect } from 'react'
import { Image, Popover } from 'antd'

const ModelLeftCom = (props) => {
    const { item, setSelectedInputImg } = props
    const refListModalRef = useRef(null)
    const getModelProviderLabel = (value) => {
        if (!value) return ''
        if (value === MODEL_PROVIDER.SOTA || value?.toLowerCase?.() === 'sota') return '全能模型'
        if (value === MODEL_PROVIDER.ARCMUSE || value?.toLowerCase?.() === 'arcmuse') return 'ArcMuse'
        return value
    }
    const getModeLabel = (mode, provider, forceHq = false) => {
        const isSota = provider === MODEL_PROVIDER.SOTA || provider?.toLowerCase?.() === 'sota'
        const isHq = forceHq || mode != 'std'
        if ((item?.imageType || item?.attr?.imageType) === IMAGE_TYPE.NECKLACE_TRYON) return isHq ? '全能模型·高品质4K' : '全能模型·标准2K'
        if (isSota) return isHq ? '高品质模式4K' : '标准模式2K'
        return isHq ? '高品质模式' : '标准模式'
    }
    const getSmartDetailModeLabel = () => {
        const refTemplate = item?.attr?.refTemplate || item?.refTemplate
        return refTemplate ? '参考图模式' : '自定义模式'
    }
    const getSmartDetailPlatformLabel = (value) => {
        if (!value) return ''
        return SMART_DETAIL_PLATFORM_LABEL_MAP?.[value] || value
    }
    const getSmartDetailLangLabel = (value) => {
        if (!value) return ''
        return SMART_DETAIL_LANG_LABEL_MAP?.[value] || value
    }
    const getAspectRatioLabel = (value) => {
        if (!value) return ''
        return value === 'smart' ? '智能' : value
    }

    const title = (
        <div className={styles.section}>
            <p className={styles.headerTitle}>{item?.projectName}</p>
            <p className={styles.headerSubTitle}>{item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
                item?.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                    item?.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                        item?.projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                            item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                                item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去水印' :
                                    item?.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                        item?.projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '种草图' :
                                            item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '图生视频' :
                                                item?.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '服装详情页' :
                                                    '商品智能堆叠'}</p>
            <p className={styles.label}>{item?.createdTime}</p>
            <p className={styles.label}>创建人</p>
            <p className={styles.value}>{item?.memberName}</p>
        </div>
    )

    const mode = (
        <div className={styles.section}><p className={styles.label}>生成模式</p><p className={styles.value}>{getModeLabel(item?.attr?.mode, item?.attr?.modelProvider || item?.modelProvider, item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && (item?.attr?.imageTail || item?.imageTail))}</p></div>
    )
    const modelProvider = (
        (item?.attr?.modelProvider || item?.modelProvider) ? <div className={styles.section}><p className={styles.label}>模型选择</p><p className={styles.value}>{getModelProviderLabel(item?.attr?.modelProvider || item?.modelProvider)}</p></div> : null
    )
    const duration = (
        <div className={styles.section}><p className={styles.label}>视频时长</p><p className={styles.value}>{item?.attr?.duration == 10 ? '10秒' : '5秒'}</p></div>
    )
    const skinRefine = (
        <div className={styles.section}><p className={styles.label}>肤质优化</p><p className={styles.value}>{item?.attr?.skinRefine ? '开启' : '关闭'}</p></div>
    )
    const emoji = (
        <div className={styles.section}><p className={styles.label}>模特表情</p><p className={styles.value}>{item?.attr?.emoji == MODEL_EXPRESSION.REF ? '按模特参考图' : '按原模特'}</p></div>
    )
    const customBkgMode = (
        <div className={styles.section}><p className={styles.label}>背景模式</p><p className={styles.value}>{item?.attr?.customBkgMode == 'free' ? '变化更多' : '场景不变'}</p></div>
    )
    const relight = (
        <div className={styles.section}><p className={styles.label}>光影增强</p><p className={styles.value}>{item?.attr?.relight > 0 ? '开启' : '关闭'}</p></div>
    )
    const relightMode = <div className={styles.section}><p className={styles.label}>光影模式</p><p className={styles.value}>{item?.attr?.relightMode === RELIGHT_MODE.REFLECTOR ? "反光板模式" : "标准模式"}</p></div>

    const inputImg = (
        <div className={styles.section}>
            <p className={styles.label}>{item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' :
                item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '输入图' :
                    item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '源素材' :
                        item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '首帧图' :
                            '模特图'}
                <span style={{ marginLeft: '30px' }}>{(item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && (item?.attr?.imageTail || item?.imageTail)) && '尾帧图'}</span>
            </p>
            <div className={styles.imageList}>
                <img
                    src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => i.mainImage)?.[0]?.url)}
                    className={setSelectedInputImg ? (props.selectedInputImg == item?.inputImages?.filter((i) => i.mainImage)?.[0]?.url ? styles.active : '') : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => setSelectedInputImg && setSelectedInputImg(item?.inputImages?.filter((i) => i.mainImage)?.[0]?.url)}
                    alt=""
                />
                {
                    item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && (item?.attr?.imageTail || item?.imageTail) && <img
                        key={item?.attr?.imageTail || item?.imageTail}
                        src={Utils.getImgThumbnail(item?.attr?.imageTail || item?.imageTail)}
                        className={setSelectedInputImg ? (props.selectedInputImg == (item?.attr?.imageTail || item?.imageTail) ? styles.active : '') : ''}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setSelectedInputImg && setSelectedInputImg(item?.attr?.imageTail || item?.imageTail)}
                        alt=""
                    />
                }
            </div>
        </div>
    )
    const resolutionAlign = (
        <div className={styles.section}><p className={styles.label}>比例参照</p><p className={styles.value}>{item?.attr?.resolutionAlign == RESOLUTION_ALIGN.INPUT ? '按上传图比例生成' : '按参考图比例生成'}</p></div>
    )
    const poseImg = (
        <div className={styles.section}>
            <p className={styles.label}>姿势参考图</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.attr?.pose?.url)} alt="" />
            </div>
        </div>
    )
    const modelImg = (
        item?.attr?.person?.url && <div className={styles.section}>
            <p className={styles.label}>{item?.projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '网红图' : '模特参考图'}</p>
            {!item?.keepPose && <div className={styles.imageList}><img src={Utils.getImgThumbnail(item?.attr?.person?.url)} alt="" /></div>}
        </div>
    )

    const bkgImg = (
        item?.attr?.background?.url && <div className={styles.section}>
            <p className={styles.label}>{item?.projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '背景氛围图' : '背景参考图'}</p>
            {!item?.keepPose && <div className={styles.imageList}><img src={Utils.getImgThumbnail(item?.attr?.background?.url)} alt="" /></div>}
        </div>
    )
    const matchImg = (
        item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url && <div className={styles.section}>
            <p className={styles.label}>搭配参考图</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url)} alt="" />
            </div>
        </div>
    )
    const inputCloth = (
        item?.attr?.inputCloth && <div className={styles.section}>
            <p className={styles.label}>{item?.attr?.flatType === 'material' ? '面料图' : '同款不同色平铺图'}</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.attr?.inputCloth)} alt="" />
            </div>
        </div>
    )
    const matchCloth = (
        item?.attr?.matchCloth && <div className={styles.section}>
            <p className={styles.label}>搭配图</p>
            <div className={styles.imageList}>
                <img src={Utils.getImgThumbnail(item?.attr?.matchCloth)} alt="" />
            </div>
        </div>
    )
    // 堆叠辅品图
    const refListImg = (
        item?.attr?.refList?.[0]?.url && <div className={styles.section}>
            <p className={styles.label}>辅品图</p>
            <div className={styles.imageList}>
                {<p className={styles.imgNum} style={{ width: '100%' }}>数量{item?.attr?.refList?.[0]?.num}</p>}
                {item?.attr?.refList?.map((img, index) => (
                    <img key={index} src={Utils.getImgThumbnail(img?.url)} alt="" />
                ))}
            </div>
        </div>
    )
    // 服装详情页图
    const smartInputImgs = (
        item?.inputImages?.[0]?.url && <div className={styles.section}>
            <p className={styles.label}>详情页图片</p>
            <div className={styles.imageList}>
                {item?.inputImages?.map((img, index) => (
                    <img key={index} src={Utils.getImgThumbnail(img?.url)} alt="" />
                ))}
            </div>
        </div>
    )

    // 搭配上身图
    const matchImages = (
        item?.inputImages && <div className={styles.section}>
            <p className={styles.label}>搭配图</p>
            <div className={styles.imageList}>
                {item?.inputImages?.map((img, index) => (
                    <img
                        key={index}
                        src={Utils.getImgThumbnail(img?.url)}
                        className={setSelectedInputImg ? (props.selectedInputImg == img?.url ? styles.active : '') : ''}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setSelectedInputImg && setSelectedInputImg(img?.url)}
                        alt=""
                    />
                ))}
            </div>
        </div>
    )

    // 提示词
    const promptTextRef = useRef(null)
    const [promptOverflow, setPromptOverflow] = useState(false)
    const [promptPopoverOpen, setPromptPopoverOpen] = useState(false)
    const promptText = useMemo(() => {
        return item?.attr?.prompt
    }, [item])
    const checkPromptOverflow = () => {
        const el = promptTextRef.current
        if (!el) {
            setPromptOverflow(false)
            return
        }

        const computedStyle = window.getComputedStyle(el)
        const measureEl = document.createElement('div')
        measureEl.textContent = promptText || ''
        measureEl.style.position = 'fixed'
        measureEl.style.left = '-9999px'
        measureEl.style.top = '0'
        measureEl.style.visibility = 'hidden'
        measureEl.style.pointerEvents = 'none'
        measureEl.style.zIndex = '-1'
        measureEl.style.boxSizing = 'border-box'
        measureEl.style.width = `${el.clientWidth}px`
        measureEl.style.fontSize = computedStyle.fontSize
        measureEl.style.fontWeight = computedStyle.fontWeight
        measureEl.style.fontFamily = computedStyle.fontFamily
        measureEl.style.lineHeight = computedStyle.lineHeight
        measureEl.style.letterSpacing = computedStyle.letterSpacing
        measureEl.style.wordBreak = computedStyle.wordBreak
        measureEl.style.whiteSpace = computedStyle.whiteSpace
        measureEl.style.padding = computedStyle.padding
        measureEl.style.border = computedStyle.border
        measureEl.style.display = 'block'
        measureEl.style.webkitLineClamp = 'unset'
        measureEl.style.setProperty('-webkit-line-clamp', 'unset')
        measureEl.style.setProperty('-webkit-box-orient', 'initial')
        measureEl.style.overflow = 'visible'

        document.body.appendChild(measureEl)
        const lineHeight = parseFloat(computedStyle.lineHeight) || 20
        const maxHeight = lineHeight * 4
        const fullHeight = measureEl.scrollHeight
        document.body.removeChild(measureEl)

        setPromptOverflow(fullHeight > maxHeight + 1)
    }
    useEffect(() => {
        let destroyed = false
        let frameId = 0
        const runCheck = () => {
            cancelAnimationFrame(frameId)
            frameId = requestAnimationFrame(() => {
                if (destroyed) return
                checkPromptOverflow()
            })
        }

        runCheck()

        const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(runCheck) : null
        if (promptTextRef.current && resizeObserver) {
            resizeObserver.observe(promptTextRef.current)
        }

        const handleResize = () => runCheck()
        window.addEventListener('resize', handleResize)

        if (document.fonts?.ready) {
            document.fonts.ready.then(() => {
                if (!destroyed) runCheck()
            })
        }

        return () => {
            destroyed = true
            cancelAnimationFrame(frameId)
            resizeObserver?.disconnect()
            window.removeEventListener('resize', handleResize)
        }
    }, [promptText])
    const prompt = (
        <div className={styles.section}>
            <div className={styles.promptWrap}>
                <div className={styles.promptTextWrap}>
                    <p className={styles.label}>描述</p>
                    <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                    {promptOverflow && (
                        <Popover
                            open={promptPopoverOpen}
                            onOpenChange={setPromptPopoverOpen}
                            trigger="hover"
                            placement="bottom"
                            content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>
            </div>
        </div>
    )
    const smartDetailRefTemplate = item?.attr?.refTemplate?.url || item?.attr?.refTemplate?.image || item?.attr?.refTemplate?.cover || item?.attr?.refTemplate || item?.refTemplate
    const smartDetailReferenceImage = (
        smartDetailRefTemplate ? <div className={styles.section}>
            <p className={styles.label}>参考图</p>
            <div className={styles.imageList}>
                <Image className={styles.ReferenceImage} src={Utils.getImgThumbnail(smartDetailRefTemplate)} preview={{ src: smartDetailRefTemplate }} alt="" />
            </div>
        </div> : null
    )
    const smartDetailProductInfo = item?.attr?.prompt ? (
        <div className={styles.section}>
            <div className={styles.promptWrap}>
                <div className={styles.promptTextWrap}>
                    <p className={styles.label}>商品信息</p>
                    <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                    {promptOverflow && (
                        <Popover
                            open={promptPopoverOpen}
                            onOpenChange={setPromptPopoverOpen}
                            trigger="hover"
                            placement="bottom"
                            content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>
            </div>
        </div>
    ) : null
    const smartDetailResolution = item?.attr?.mode ? (
        <div className={`${styles.section} ${styles.inlineSection}`}>
            <p className={styles.label}>分辨率</p>
            <p className={styles.value}>{item?.attr?.mode}</p>
        </div>
    ) : null
    const smartDetailRatio = item?.attr?.aspectRatio ? (
        <div className={`${styles.section} ${styles.inlineSection}`}>
            <p className={styles.label}>生成比例</p>
            <p className={styles.value}>{getAspectRatioLabel(item?.attr?.aspectRatio)}</p>
        </div>
    ) : null
    const smartDetailPlatform = getSmartDetailPlatformLabel(item?.attr?.ecPlatform) ? (
        <div className={`${styles.section} ${styles.inlineSection}`}>
            <p className={styles.label}>电商平台</p>
            <p className={styles.value}>{getSmartDetailPlatformLabel(item?.attr?.ecPlatform)}</p>
        </div>
    ) : null
    const smartDetailLang = getSmartDetailLangLabel(item?.attr?.lang) ? (
        <div className={`${styles.section} ${styles.inlineSection}`}>
            <p className={styles.label}>语言</p>
            <p className={styles.value}>{getSmartDetailLangLabel(item?.attr?.lang)}</p>
        </div>
    ) : null



    const showConent = (
        item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? (
            <>
                {title}
                {inputImg}
                {poseImg}
                {modelImg}
                {matchImg}
                {modelProvider}
                {mode}
            </>
        ) : item?.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
            (
                <>
                    {title}
                    {inputImg}
                    {modelImg}
                    {emoji}
                    {skinRefine}
                    {relight}
                    {item?.attr?.relight > 0 && relightMode}
                </>
            ) : item?.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ?
                (
                    <>
                        {title}
                        {inputImg}
                        {bkgImg}
                        {relight}
                        {item?.attr?.relight > 0 && relightMode}
                        {customBkgMode}
                        {resolutionAlign}
                    </>
                ) : item?.projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ?
                    (
                        <>
                            {title}
                            {inputImg}
                            {modelImg}
                            {inputCloth}
                            {matchCloth}
                        </>
                    ) : item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
                        item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ?
                        (
                            <>
                                {title}
                                {inputImg}
                            </>
                        ) : item?.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ?
                            (
                                <>
                                    {title}
                                    {matchImages}
                                    {modelImg}
                                    {prompt}
                                </>
                            ) : item?.projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ?
                                (
                                    <>
                                        {title}
                                        {modelImg}
                                        {bkgImg}
                                        {mode}
                                    </>
                                ) : item?.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ?
                                    (
                                        <>
                                            {title}
                                            {inputImg}
                                            {mode}
                                            {duration}
                                            {prompt}
                                        </>
                                    ) : item?.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                                        (
                                            <>
                                                {title}
                                                {item?.inputImages?.length > 0 && (
                                                    <div className={styles.section}>
                                                        <p className={styles.label}>商品图</p>
                                                        <div className={styles.imageList}>
                                                            {item?.inputImages?.map((img, index) => (
                                                                <img
                                                                    key={index}
                                                                    src={Utils.getImgThumbnail(img?.url)}
                                                                    className={setSelectedInputImg ? (props.selectedInputImg == img?.url ? styles.active : '') : ''}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => setSelectedInputImg && setSelectedInputImg(img?.url)}
                                                                    alt=""
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={styles.section}>
                                                    <p className={styles.label}>生成方式</p>
                                                    <p className={styles.value}>{getSmartDetailModeLabel()}</p>
                                                </div>
                                                {smartDetailProductInfo}
                                                {smartDetailResolution}
                                                {smartDetailRatio}
                                                {smartDetailPlatform}
                                                {smartDetailLang}
                                                {smartDetailReferenceImage}
                                            </>
                                        ) : null
    )


    return (
        <>

            <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
                {showConent}
            </div>
            <RefListModal ref={refListModalRef} onSelect={setSelectedInputImg} />
        </>

    )
}

export default ModelLeftCom
